"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var escape_uri_1 = require("./escape-uri");
function escapeUriPath(uri) {
    var e_1, _a;
    var parts = [];
    try {
        for (var _b = tslib_1.__values(uri.split("/")), _c = _b.next(); !_c.done; _c = _b.next()) {
            var sub = _c.value;
            parts.push(escape_uri_1.escapeUri(sub));
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return parts.join("/");
}
exports.escapeUriPath = escapeUriPath;
//# sourceMappingURL=escape-uri-path.js.map